import { Box } from '@material-ui/core';
import React from 'react';
import moment from 'moment';
import { makeStyles, withTheme } from '@material-ui/styles';
import { BOOKING_STATE_BORDER_COLORS, BOOKING_STATE_COLORS } from '../../../bookingStates';

const useStyles = makeStyles({
    eventDynamic: {
        borderLeft: props =>
            `3px solid ${BOOKING_STATE_BORDER_COLORS[props.status] ||
                BOOKING_STATE_BORDER_COLORS.unconfirmed}`,
        background: props => BOOKING_STATE_COLORS[props.status] || BOOKING_STATE_COLORS.unconfirmed,
        // the day shift + the swimlane thing
        left: props =>
            `calc(((100% / ${props.weekDays}) * ${props.dayIdx}) + ((100% / ${props.weekDays})* ${props.swim_idx} / ${props.swim_count}))`,
        right: props => `calc((100% / ${props.weekDays}) * ${props.weekDays - 1 - props.dayIdx})`,
        top: props => `${props.top.toFixed(2)}%`,
        bottom: props => `${props.bottom}%`,
        zIndex: props => props.eventIdx
    },
    seats: {
        marginTop: '0.5rem',
        marginBottom: 0,
        fontSize: '1rem',
        fontWeight: 'bold'
    }
});

const CalendarEvent = ({ event, eventIdx, weekDays, hours, cellHeight, onEventClick }) => {
    const visibleRangeInMinutes = (hours[1] - hours[0]) * cellHeight;

    const classes = useStyles({
        status: event.status,
        dayIdx: event.event_day_idx,
        weekDays,
        swim_count: event.event_swimlane_count,
        swim_idx: event.event_swimlane_idx,
        // 100 for %, hour within the day - the visible interval start per whole day range
        top: (100 * (event.event_start_inday - hours[0] * 60)) / visibleRangeInMinutes,
        // same as top, but calculated from the bottom (end of day, hours[1]
        bottom: (100 * (hours[1] * 60 - event.event_end_inday)) / visibleRangeInMinutes,
        eventIdx
    });

    const { isSeatEvent, availableSeats, extraInfo } = event;

    const dateValue = moment(event.activity_start).format('h:mm a');

    return (
        <Box
            className={`${classes.eventDynamic} event ${event.classNames?.join(' ')}`}
            onClick={() => onEventClick(event)}
        >
            <p style={{ margin: 0 }}>{dateValue}</p>
            {typeof event.paxCount !== 'undefined' ? (
                <>
                    <p style={{ marginTop: 1 }} className={classes.seats}>
                        {event.paxCount} PAX
                    </p>
                    <p style={{ margin: 0 }}>
                        {event.groupCount} Group{event.groupCount === 1 ? '' : 's'}
                    </p>
                </>
            ) : isSeatEvent ? (
                <>
                    <p style={{ marginTop: 1 }} className={classes.seats}>
                        {availableSeats}
                    </p>
                    <p style={{ margin: 0 }}>Seat{availableSeats === 1 ? '' : 's'}</p>
                </>
            ) : (
                <p style={{ marginTop: '0.5rem' }}>{event?.tickets?.length} Ticket</p>
            )}
            <small style={{ margin: 0 }}>{extraInfo}</small>
        </Box>
    );
};

export default withTheme(CalendarEvent);
